// @ts-check
export const getDrugSort = (alwaysTop = {}) => (a, b) => {
  const aInTop = alwaysTop[a.name] || 0
  const bInTop = alwaysTop[b.name] || 0

  if (aInTop > bInTop) {
    return -1
  }

  if (bInTop > aInTop) {
    return 1
  }

  if (a.favorite && !b.favorite) {
    return -1
  }
  if (b.favorite && !a.favorite) {
    return 1
  }

  return a.name.localeCompare(b.name)
}

export const drugSort = getDrugSort()
